window.addEventListener('DOMContentLoaded', () => {
  const pdpMobileSizeCheckbox = document.getElementById('product__size-selector-checkbox');
  const pdpMobileSizeOverlay = document.getElementById('product__size-selector-overlay');
  const pdpAddToCartWrapper = document.querySelector('.product-form__item--submit');
  const pdpSizePickerWrapper = document.getElementById('product-form__variants-boxes');

  const sizeSwitcher = document.getElementById('product__size-switches');
  const raffleSizeSwitcher = document.getElementById('raffle__size-switches');
  
  const usSizeSwitcher = document.getElementById('size-switch--us');
  const euSizeSwitcher = document.getElementById('size-switch--eu');
  const ukSizeSwitcher = document.getElementById('size-switch--uk');
  const sizeChartLabels = document.querySelectorAll('.single-option_label');
  const sizeSelectorLabel = document.querySelector('.product__size-selector-label');
  const sizeLabels = [...sizeChartLabels, sizeSelectorLabel];
  sizeChartLabels.forEach(label => label.addEventListener('click', () => {
    // change value
    sizeSelectorLabel.innerHTML = label.innerHTML
    if (sizeSwitcher) {
      // change data-values
      sizeSelectorLabel.dataset.usSize = label.dataset.usSize
      sizeSelectorLabel.dataset.ukSize = label.dataset.ukSize
      sizeSelectorLabel.dataset.euSize = label.dataset.euSize
    }
    // Clicking a new size closes the size selector on mobile
    if (pdpMobileSizeOverlay) {
      pdpMobileSizeCheckbox.checked = false;
    }
  }))

  pdpMobileSizeOverlay && pdpMobileSizeOverlay.addEventListener('click', e => {
    e.preventDefault()
    pdpMobileSizeCheckbox.checked = false;
  })

  pdpAddToCartWrapper && pdpAddToCartWrapper.addEventListener('click', () => {
    // (mobile only) open size selector if no variant is selected
    if (pdpSizePickerWrapper) {
      const currentSizeChartLabels = Array.from(pdpSizePickerWrapper.querySelectorAll('input'));
      if (currentSizeChartLabels.findIndex(input => input.checked) === -1 && window.innerWidth < 1024) {
        pdpMobileSizeCheckbox.checked = true;
      }
    }
  })

  const setSizes = region => {
    sizeLabels.forEach(label => {
      // first check if label has a data-us-size (in case it's first load and there is no current_variant for the product__size-selector-label
      if (label.dataset.usSize) {
        switch(region) {
          case 'us':
            label.innerHTML = label.dataset.usSize;
            break;
          case 'eu':
            label.innerHTML = label.dataset.euSize;
            break;
          case 'uk':
            label.innerHTML = label.dataset.ukSize;
            break;
        }
      }
    })
  }
  
  async function setSizesByLocale() {
    const url = window.location.origin + '/browsing_context_suggestions.json';
    const obj = await (await fetch(url)).json();
    const locale = obj.detected_values.country.handle;
    const usCountryCodes = ['CG', 'ZA', 'RE', 'NG', 'EG', 'LS', 'SN', 'LR', 'AO', 'BF', 'BI', 'BJ', 'BW', 'CD', 'CF', 'CI', 'CM', 'CV', 'DJ', 'DZ', 'EH', 'ER', 'ET', 'GA', 'GH', 'GM', 'GN', 'GQ', 'GW', 'KE', 'KM', 'LY', 'MA', 'MG', 'ML', 'MR', 'MU', 'MW', 'MZ', 'NA', 'NE', 'RW', 'SC', 'SD', 'SH', 'SL', 'SO', 'SS', 'ST', 'SZ', 'TD', 'TG', 'TN', 'TZ', 'UG', 'YT', 'ZM', 'ZW', 'AQ', 'BV', 'GS', 'HM', 'TF', 'HK', 'JP', 'KR', 'SG', 'CN', 'AE', 'MY', 'TW', 'ID', 'PH', 'VN', 'MO', 'IL', 'TH', 'KW', 'MM', 'GE', 'BN', 'BH', 'SA', 'IN', 'LB', 'KZ', 'AF', 'AM', 'AZ', 'BD', 'BT', 'CC', 'IO', 'IQ', 'IR', 'JO', 'KG', 'KH', 'KP', 'LA', 'LK', 'MN', 'MV', 'NP', 'OM', 'PK', 'PS', 'QA', 'SY', 'TJ', 'TM', 'TR', 'UZ', 'YE', 'US', 'CA', 'MX', 'PR', 'GP', 'JM', 'MS', 'MF', 'AG', 'AI', 'AN', 'AW', 'BB', 'BL', 'BM', 'BQ', 'BS', 'BZ', 'CR', 'CU', 'CW', 'DM', 'DO', 'GD', 'GL', 'GT', 'HN', 'HT', 'KN', 'KY', 'LC', 'MQ', 'NI', 'PA', 'PM', 'SV', 'SX', 'TC', 'TT', 'VC', 'VG', 'VI', 'AU', 'NZ', 'FM', 'AS', 'CK', 'CX', 'FJ', 'GU', 'KI', 'MH', 'MP', 'NC', 'NF', 'NR', 'NU', 'PF', 'PG', 'PW', 'SB', 'TK', 'TL', 'TO', 'TV', 'VU', 'WF', 'WS', 'PN', 'UM', 'BR', 'CL', 'AR', 'BO', 'CO', 'EC', 'FK', 'GF', 'GY', 'PE', 'PY', 'SR', 'UY', 'VE'];
    const ukCountryCodes = ['GB', 'IE'];

    if (usCountryCodes.includes(locale)) {
      usSizeSwitcher.checked = true;
      setSizes("us");
    } else if (ukCountryCodes.includes(locale)) {
      ukSizeSwitcher.checked = true;
      setSizes("uk");
    } else {
      euSizeSwitcher.checked = true;
      setSizes("eu");
    }
  }
  
  sizeSwitcher && sizeSwitcher.addEventListener('change', e => setSizes(e.target.value));
  sizeSwitcher && setSizesByLocale();
  
  raffleSizeSwitcher && raffleSizeSwitcher.addEventListener('change', e => setSizes(e.target.value));
  raffleSizeSwitcher && setSizesByLocale();
})